module.exports = __webpack_public_path__ + "static/img/de-Leeuw-Jan.9aa8523.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/nl/de-Leeuw-Jan.jpg
// module id = H+MW
// module chunks = 1